
    import * as React from 'react';

    const Warning16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0-.75a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zM7.6 3.5h.75V10H7.6V3.5zm.407 7.5l.707.707-.707.707-.707-.707.707-.707z" /></svg>
        </div>
      );
    };

    Warning16.displayName = 'Warning16';

    export default Warning16;
  